import React from 'react';
import { Divider } from '@/app/(main)/clients/create/components/Divider';
import { PrimaryBillingAddress } from '@/app/(main)/clients/create/components/PrimaryPassengerBilling';
import { DietaryRestrictions } from '@/app/(main)/clients/create/components/PrimaryPassengerDietaryRestrictions';
import { EmergencyContact } from '@/app/(main)/clients/create/components/PrimaryPassengerEmergencyContacts';
import { FlightPreferences } from '@/app/(main)/clients/create/components/PrimaryPassengerFlightPreferences';
import { LoyaltyProgram } from '@/app/(main)/clients/create/components/PassengerLoyaltyProgram';
import { PrimaryTravelData } from '@/app/(main)/clients/create/components/PrimaryPassengerTravelData';
import { TravelPreferencesByCategory } from '@/app/(main)/clients/create/components/PrimaryPassengerTravelPreferencesByCategory';
import { SectionAccordion } from '@/app/(main)/clients/create/components/SectionAccordion';
import { AirportsList } from './components/AirportsList';
import type{ EditClientResponse } from '@/types/clientsApiTypes';
import type { RelatedDataKeys } from '../../hooks/useUpdateTravelPreferencesWithRelatedData/types';

interface PrimaryPassengerTravelPreferencesProps {
  onUpdateFormData?: (fieldName: string, fieldValue: unknown) => Promise<EditClientResponse | undefined>;
  onUpdateTravelPreferences?: (fieldName: string, fieldValue: unknown) => Promise<EditClientResponse | undefined>;
  onUpdateTravelPreferencesWithRelatedData?: (fieldKey: RelatedDataKeys, fieldName: string, fieldValue: unknown, fullPath: string) => Promise<EditClientResponse | undefined>;
  onDeleteLoyaltyProgram?: (lpId: number) => Promise<void>;
}

export const PrimaryPassengerTravelPreferences = ({
  onUpdateFormData,
  onUpdateTravelPreferences,
  onUpdateTravelPreferencesWithRelatedData,
  onDeleteLoyaltyProgram,
}: PrimaryPassengerTravelPreferencesProps) => {
  return (
    <div>
      <AirportsList title="Preferred Home Airport(s)" onUpdateFormData={onUpdateFormData} />
      <Divider />
      <SectionAccordion
        headerClassName="!font-semibold"
        as="h5"
        className="py-0"
        sectionClassName="py-0"
        isHiddenBorder
        header="Emergency Contact"
      >
        <EmergencyContact onUpdateFormData={onUpdateFormData} />
      </SectionAccordion>
      <Divider />
      <SectionAccordion
        headerClassName="!font-semibold"
        as="h5"
        className="py-0"
        sectionClassName="py-0"
        isHiddenBorder
        header="Billing Address"
      >
        <PrimaryBillingAddress onUpdateFormData={onUpdateFormData} />
      </SectionAccordion>
      <Divider />
      <SectionAccordion
        headerClassName="!font-semibold"
        as="h5"
        className="py-0"
        sectionClassName="py-0"
        isHiddenBorder
        header="Travel Data"
      >
        <PrimaryTravelData onUpdateFormData={onUpdateFormData} />
      </SectionAccordion>
      <Divider />
      <SectionAccordion
        headerClassName="!font-semibold"
        as="h5"
        className="py-0"
        sectionClassName="py-0"
        isHiddenBorder
        header="Loyalty Program"
        description="Applied across flights, hotels, and experiences when relevant."
      >
        <LoyaltyProgram onUpdateFormData={onUpdateFormData} onDeleteLoyaltyProgram={onDeleteLoyaltyProgram} />
      </SectionAccordion>
      <Divider />
      <SectionAccordion
        headerClassName="!font-semibold"
        as="h5"
        className="py-0"
        sectionClassName="py-0"
        isHiddenBorder
        header="Allergies & Dietary Restrictions"
      >
        <DietaryRestrictions onUpdateFormData={onUpdateTravelPreferences} />
      </SectionAccordion>
      <Divider />
      <SectionAccordion
        headerClassName="!font-semibold"
        as="h5"
        className="py-0"
        sectionClassName="py-0"
        isHiddenBorder
        header="Flight Preferences"
      >
        <FlightPreferences onUpdateTravelPreferencesWithRelatedData={onUpdateTravelPreferencesWithRelatedData} />
      </SectionAccordion>
      <Divider />
      <SectionAccordion
        headerClassName="!font-semibold"
        as="h5"
        className="py-0"
        sectionClassName="py-0"
        isHiddenBorder
        header="Travel Preferences by Category"
      >
        <TravelPreferencesByCategory onUpdateTravelPreferencesWithRelatedData={onUpdateTravelPreferencesWithRelatedData} />
      </SectionAccordion>
    </div>
  );
};
